import React from 'react';
import "./footer.css";
import Seperator from '../common/social-contact/seperator';

function Footer() {
    return (
        <div className="footer">
            <div className="line"></div>
        
            Made by <span className="color">Atul Sharma</span>
        </div>
    )
}

export default Footer
